import React, { useEffect, useRef, useState } from 'react';
import { downloadReport, exhibitorTypeActionId, toastError, toastSuccess, disclaimer } from "../utils/constants";




const Footer = ({ head, userId }) => {
  // The footer is fixed over the bottom of the page and its disclaimer wraps to
  // more lines on narrower screens (~200px tall at 1024px), so the last part of
  // the page could never be scrolled out from under it. Reserve the same height
  // at the end of the page.
  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    const el = footerRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(() => setFooterHeight(el.offsetHeight));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <>

      <div className="" style={{ bottom: '0px !important' }}>
        {/* spacer, same visibility as the footer (lg and up) */}
        <div className="d-none d-lg-block" style={{ height: footerHeight }}></div>
        <div ref={footerRef} className='footer-out d-none d-lg-block' style={{ position: 'fixed', bottom: '0px', width: '100%' }}>
          <div className="footer-sec">
            <strong>Disclaimer and Ownership:</strong>{disclaimer}
          </div>
          <div className="footer-first">
            ITME All Rights Reserved <i class="fa fa-copyright"></i> 2025
          </div>
        </div>
      </div>

    </>
  );
}
export default Footer;
